var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card3"},[_c('p',[_c('span',{staticClass:"fs18"},[_vm._v("\n      Финиш!\n    ")]),_vm._v("\n    Запоминающая поездка на завод ждет тебя\n  ")]),_vm._v(" "),_c('img',{attrs:{"src":require("../../../assets/MyProgress/factory.svg"),"alt":"factory icon"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d9511a4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./Content/src/components/MyProgress/Daccord/FinishBanner.vue
// module id = 907
// module chunks = 1